<template lang="pug">
  ul.b-footer-menu.list-reset
    li._item(v-for="item in items" :key="item.text")
      router-link._link(:to="{ name: item.route }") {{ item.text }}
</template>

<script>
export default {
  name: 'FooterMenu',
  data() {
    return {
      items: [
        { text: 'Главная', route: 'home' },
        { text: 'Проекты', route: 'project-list' },
        { text: 'Аккаунт', route: 'account' },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.footer-menu {
  display: grid;
  column-gap: 16px;
  row-gap: 16px;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  &__link {
    font-size: 13px;
    letter-spacing: 0.02em;
    color: var(--main-bg);
    line-height: 28px;
    transition: color 0.2s;
    &:hover {
      color: #5AD9D1;
    }
  }
  @media (max-width: 1024px) {
    grid-column: 8 span;
    padding-right: 10px;
  }

  @media (max-width: 768px) {
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    margin-bottom: 40px;
  }

  @media (max-width: 576px) {
    &__link {
      font-size: 11px;
    }
  }

  @media (max-width: 500px) {
    &__link {
      font-size: 10px;
      line-height: 15px;
    }
  }
}
</style>
